// extracted by mini-css-extract-plugin
export default {"votes":"Votes_votes__TqroX","list":"Votes_list__5iolF","tabs":"Votes_tabs__jNTth","badge":"Votes_badge__QNTak","empty":"Votes_empty__sge9j"};